import { render, staticRenderFns } from "./SupplierImportUpload.vue?vue&type=template&id=0ff90a58&scoped=true"
import script from "./SupplierImportUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupplierImportUpload.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SupplierImportUpload.vue?vue&type=style&index=0&id=0ff90a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff90a58",
  null
  
)

export default component.exports